import { useEffect, useRef } from "react";
import { BellRing, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { useApp } from "../context/AppContext";
import { useThemeMode } from "../context/ThemeContext";
import { followPostNotice, noticeLink, showBrowserPostNotice } from "../lib/follow-notifications";

export function FollowNotifications() {
  const { user } = useApp();
  const { mode } = useThemeMode();
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;
  useEffect(() => {
    if (!user) return;
    let disposed = false;
    const seen = new Set<string>();
    const toastIds = new Set<string>();
    const receive = (event: Event) => {
      const notice = followPostNotice((event as CustomEvent<unknown>).detail, user.id);
      if (!notice || seen.has(notice.id)) return;
      seen.add(notice.id);
      if (seen.size > 200) seen.delete(seen.values().next().value!);
      const toastId = `follow-post:${notice.id}`;
      toastIds.add(toastId);
      toast.custom(() => <div className="follow-post-toast">
        <span className="follow-post-toast-icon"><BellRing aria-hidden="true" /></span>
        <div><strong>关注的人有新文案</strong><p>{notice.message}</p>
          <button type="button" className="follow-post-toast-action" onClick={() => { toast.dismiss(toastId); navigateRef.current(noticeLink(notice.id)); }}>查看文案</button>
        </div>
        <button type="button" className="follow-post-toast-close" aria-label="关闭新文案提醒" onClick={() => toast.dismiss(toastId)}><X aria-hidden="true" /></button>
      </div>, { id: toastId, duration: 8000, onDismiss: () => toastIds.delete(toastId), onAutoClose: () => toastIds.delete(toastId) });
      void showBrowserPostNotice(notice, () => !disposed).catch(() => undefined);
    };
    window.addEventListener("share-moments:notification.created", receive);
    return () => { disposed = true; window.removeEventListener("share-moments:notification.created", receive); toastIds.forEach((id) => toast.dismiss(id)); };
  }, [user?.id]);
  return <Toaster theme={mode} position="bottom-right" visibleToasts={3} mobileOffset={{ bottom: "calc(80px + env(safe-area-inset-bottom))", left: 16, right: 16 }} offset={24} />;
}
